// The item generator: family id → part builder (every family incl. v0.2), guns via the part-kit.
import { drawGun } from '../parts/gun/assemble.ts';
import type { Part } from '../passes.ts';
import type { Generator, ItemSpec } from '../types.ts';
import { ammoLadder } from './ammo.ts';
import { drawItemParts, type ItemKit } from './kit.ts';
import { barLadder, barrelLadder, frameLadder, powderLadder, unitLadder } from './materials.ts';
import { oreParts } from './ores.ts';

const FAMILIES: Record<string, (k: ItemKit) => Part[]> = {
  ore_lead: (k) => oreParts(k, 'ore_lead'),
  ore_coal: (k) => oreParts(k, 'ore_coal'),
  ore_copper: (k) => oreParts(k, 'ore_copper'),
  ore_iron: (k) => oreParts(k, 'ore_iron'),
  slug: (k) => unitLadder(k, 'slug'),
  casing: (k) => unitLadder(k, 'casing'),
  powder: powderLadder,
  cbar: (k) => barLadder(k, 'material.copper'),
  sbar: (k) => barLadder(k, 'material.steel'),
  barrel: barrelLadder,
  frame: frameLadder,
  ammo: ammoLadder,
};

export const itemGen: Generator<ItemSpec> = (c, spec, px, env) => {
  if (spec.fam === 'gun') {
    drawGun(c, spec, px, env);
    return;
  }
  const build = FAMILIES[spec.fam];
  if (!build) throw new Error(`art: no generator for item family "${spec.fam}"`);
  drawItemParts(c, spec, px, env, build);
};
